// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e858e143","455":"a798c20c","977":"62e5f961"}[chunkId] + ".chunk.js";
};